export default __webpack_public_path__ + "static/media/madalina.d0c024c5.jpg";